import { Injectable } from '@tanbo/vue-di-plugin'
import { HttpInterceptor } from '@zhfe/common-library'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HmacMD5 from 'crypto-js/hmac-md5'
import Hex from 'crypto-js/enc-hex'
import { openWxLogin } from '@/services/wechat/wxOauth.service'
import { KENIU_URL } from '@/common/config'
import { CookieService } from './cookie.service';

export interface CommonRequestFields {
  uid?: string,
  token?: string,
  app_id?: string,
  open_id?: string
}

export class ResponseError extends Error {
  name = 'ResponseError'

  constructor (responseBody: any, msg?: string) {
    super(msg)
  }
}

const AuthExpiredArr = [4001002, 4001004]

@Injectable()
export class HttpInterceptorService implements HttpInterceptor<any> {
  private commonRequestFields: CommonRequestFields = {}

  constructor(private cookie: CookieService) {}

  request(request: AxiosRequestConfig) {
    if (this.isKeNiuRequest(request)) {
      return this.requestKeniu(request)
    }
    return this.requestCommon(request)
  }

  isKeNiuRequest (request: AxiosRequestConfig) {
    return request.url.startsWith(KENIU_URL)
  }

  requestCommon (request: AxiosRequestConfig) {
    request.headers.common['X-CF-From'] = ''
      if (request.data) {
        request.data.common = {
          ...this.commonRequestFields
        }
      } else if (request.params) {
        request.params = {
          ...this.commonRequestFields
        }
      }

      return request
  }

  /** 使用HMAC-md5 对 request body 签名, 使用的 key 根据 X-Cf-Productid 头部字段而定，获得该摘要的 hex 形式小写字符串 */
  getSignature(request: AxiosRequestConfig) {
    const body = JSON.stringify(request.data)
    const key = 'sfjfkj8328qwisvig389389bvizscdwf'
    return HmacMD5(body, key).toString(Hex)
  }

  requestKeniu (request: AxiosRequestConfig) {
    const appId = '104'
    this.addCommonRequestFields({ app_id: appId })
    request = this.requestCommon(request)
    request.headers.common = {
      'X-Cf-Appid': appId,
      'X-Cf-Authorization': this.getSignature(request),
      'X-Cf-Productid': appId
    }
    return request
  }

  response(response: AxiosResponse) {
    const body = response.data
    body.resp_common = body.resp_common || {}
    const { ret, msg } = body.resp_common

    if (ret === 0) { return body }

    if (AuthExpiredArr.includes(ret)) {
      this.cookie.removeUserInfo()
      openWxLogin()
      return Promise.reject(new ResponseError('登录失效，请重新登录!'))
    }
    return Promise.reject(new ResponseError(body.resp_common, msg || '未知错误！'))
  }

  addCommonRequestFields (params: CommonRequestFields) {
    Object.assign(this.commonRequestFields, params)
  }
}
